import $ from "jquery";
import Venobox from 'venobox';
import Swiper from 'swiper';
import { Pagination,Navigation } from 'swiper/modules';
import { uaCheck,showAccordion,mq } from "./modules/utils";
// eslint-disable-next-line
import 'swiper/css';
// eslint-disable-next-line
import 'swiper/css/pagination';
// eslint-disable-next-line
import 'swiper/css/navigation';
import '../../node_modules/venobox/dist/venobox.min.css'

// venobox
const popFunc = () => {
  const venobox = new Venobox({
    selector: '.venobox',
    navigation: false,
    titlePosition: 'bottom',
  });
}

// ハンバーガーボタン
const hbgMenu = () => {
  $('.nav').on('click',() => {
    $('.nav').toggleClass('is-open');
    $('.nav-wrap').toggleClass('is-open');
    $('.nav-wrap .nav-list').toggleClass('is-open');
    $('.nav-toggle').toggleClass('is-open');
    $('.hbg-bg').toggleClass('is-open');
  })
}

// swiper

// LOOPありoption
const optionNormal = {
  loop: true,
  initialSlide: 0,
  speed: 500,
  slidesPerView:1.3,
  spaceBetween:30,
  modules: [Pagination,Navigation],
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints:{
    768:{
      slidesPerView: 2.3,
      speed: 630,
      spaceBetween: 70,
    }
  },
};
// Loopなしoption
const optionNoLoop = {
  initialSlide: 0,
  speed: 550,
  slidesPerView:1.3,
  spaceBetween:30,
  modules: [Pagination,Navigation],
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints:{
    768:{
      slidesPerView: 2.3,
      spaceBetween: 70,
    }
  },
};

const swiper01Slide = $('.swiper01 .swiper-slide').length;
const swiper01 = () => {
  if(mq('pc')) {
    if(swiper01Slide <= 2) {
      const swiper1 = new Swiper('.swiper01', optionNoLoop);
    } else {
      const swiper1 = new Swiper('.swiper01', optionNormal);
    }
  } else {
    const swiper1 = new Swiper('.swiper01', optionNormal);
  }
}
const swiper02Slide = $('.swiper02 .swiper-slide').length;
const swiper02 = () => {
  if(mq('pc')) {
    if(swiper02Slide <= 2) {
      const swiper2 = new Swiper('.swiper02', optionNoLoop);
    } else {
      const swiper2 = new Swiper('.swiper02', optionNormal);
    }
  } else {
    const swiper2 = new Swiper('.swiper02', optionNormal);
  }
}
const swiper03Slide = $('.swiper03 .swiper-slide').length;
const swiper03 = () => {
  if(mq('pc')) {
    if(swiper03Slide <= 2) {
      const swiper3 = new Swiper('.swiper03', optionNoLoop);
    } else {
      const swiper3 = new Swiper('.swiper03', optionNormal);
    }
  } else {
    const swiper3 = new Swiper('.swiper03', optionNormal);
  }
}

window.addEventListener("DOMContentLoaded", () => {
  uaCheck();
  showAccordion('.accordion-title');
  swiper01();
  swiper02();
  swiper03();
  hbgMenu();
  popFunc();
});
